module.exports = "/../../dist/frontend/images/app-store.svg?3be79aac1ee8dd0913a25d6984f23937";